import React, { ReactNode } from 'react';
import './Patterns.css';

export interface KpiTileProps {
  label: string;
  value: ReactNode;
  /** Optional sub-line below the value (e.g. "3 paused, 4 spraying now"). */
  delta?: ReactNode;
  /** When true, applies the citrus-tinted gradient — use for the row's primary KPI only. */
  primary?: boolean;
  /** When true, indicates the value represents a problem (border + value go red). */
  alert?: boolean;
}

const KpiTile: React.FC<KpiTileProps> = ({ label, value, delta, primary, alert }) => {
  const className = [
    'pat-kpi-tile',
    primary && 'pat-kpi-tile--primary',
    alert && 'pat-kpi-tile--alert',
  ].filter(Boolean).join(' ');

  return (
    <div className={className} data-testid="kpi-tile">
      <div className="pat-kpi-tile__label">{label}</div>
      <div className="pat-kpi-tile__value">{value}</div>
      {delta && <div className="pat-kpi-tile__delta" data-testid="kpi-tile-delta">{delta}</div>}
    </div>
  );
};

export default KpiTile;
